import { render } from "./TaskTag.vue?vue&type=template&id=345fb702&scoped=true"
import script from "./TaskTag.vue?vue&type=script&lang=js"
export * from "./TaskTag.vue?vue&type=script&lang=js"

import "./TaskTag.vue?vue&type=style&index=0&id=345fb702&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345fb702"]])

export default __exports__